import React from 'react';
import PropTypes from 'prop-types';

const Loading = ({fill}) => {
  return (
    <div className="loading">
      <style jsx="true">{`
        .loading {
          position: fixed;
          top: 0;
          left: 0;
          bottom: 0;
          width: 100%;
        }
        .circle {
          display: inline-block;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 80px;
          height: 80px;
          transform: translate(-50%, -50%);
        }
        .circle div {
          box-sizing: border-box;
          display: block;
          position: absolute;
          width: 64px;
          height: 64px;
          margin: 8px;
          border: 8px solid ${fill};
          border-radius: 50%;
          animation: loading 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
          border-color: ${fill} transparent transparent transparent;
        }
        .circle div:nth-child(1) {
          animation-delay: -0.45s;
        }
        .circle div:nth-child(2) {
          animation-delay: -0.3s;
        }
        .circle div:nth-child(3) {
          animation-delay: -0.15s;
        }
        @keyframes loading {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
      <div className="circle">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

Loading.defaultProps = {
  fill: '#ed5c53',
};

Loading.propTypes = {
  fill: PropTypes.string,
};

export default Loading;
